import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable, map, take } from 'rxjs';
import { EntitlementService } from '../services/entitlement.service';
import type { CapabilityKey } from '../../shared/models/entitlements';

@Injectable({ providedIn: 'root' })
export class CapabilityGuard implements CanActivate {
  constructor(private ent: EntitlementService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const cap = route.data['capability'] as CapabilityKey;
    return this.ent.can$(cap).pipe(
      take(1),
      map((allowed) => {
        if (!allowed) {
          this.router.navigate(['/upgrade'], { queryParams: { feature: cap } });
        }
        return allowed;
      })
    );
  }
}
